// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginMainContainer--NTwAa {
  background-color: #F9FBFF;
  display: grid;
  height: 100vh;
  min-height: 100%;
  width: 100%;
  gap: 1rem;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 1fr minmax(0, 950px) 1fr;
  align-self: center;
  justify-content: center;
  color: #1A202C;
}
.loginMainContainer--NTwAa .hero--vKRgs {
  position: relative;
  grid-column: 2 / 8;
  grid-row: 2;
  align-self: center;
}
@media (max-height: 800px) {
  .loginMainContainer--NTwAa .hero--vKRgs {
    align-self: start;
  }
}
.loginMainContainer--NTwAa .hero--vKRgs h1 {
  position: relative;
  z-index: 2;
  font-size: 2.5rem;
  margin-bottom: 4rem;
}
@media (max-width: 1147px) {
  .loginMainContainer--NTwAa .hero--vKRgs h1 {
    font-size: 1.6rem;
  }
}
.loginMainContainer--NTwAa .hero--vKRgs h1 span {
  color: #10B981;
}
.loginMainContainer--NTwAa .hero--vKRgs .featureInfo--ulHeD {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  max-width: 80%;
  word-break: keep-all;
  padding: 0.25rem 0;
  border-radius: 0.25rem;
}
.loginMainContainer--NTwAa .hero--vKRgs .featureInfo--ulHeD div {
  font-size: 1.4rem;
}
@media (max-width: 1147px) {
  .loginMainContainer--NTwAa .hero--vKRgs .featureInfo--ulHeD div {
    font-size: 1rem;
  }
}
.loginMainContainer--NTwAa .hero--vKRgs .icon--BBi75 {
  width: -moz-min-content;
  width: min-content;
  margin-top: 2px;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh {
  grid-column: 8 / 12;
  grid-row: 2;
  background: #FFF;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 4rem;
  text-align: center;
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  align-self: center;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh .loginIllustration--oKMGv {
  width: 100%;
  height: auto;
  margin-top: 2rem;
  max-width: 260px;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh .logo--OkmDN img {
  height: auto;
  width: 100%;
  max-width: 250px;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh .actions--j9lGb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2rem;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh .actions--j9lGb .error--pdMVs {
  color: #DF0000;
}
.loginMainContainer--NTwAa .loginContainer--FsCPh .actions--j9lGb > span {
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .loginMainContainer--NTwAa {
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto 1fr;
    padding: 2rem 0;
    height: 100%;
  }
  .loginMainContainer--NTwAa .hero--vKRgs {
    position: relative;
    grid-column: 2 / 12;
    grid-row: 2;
    padding: 1rem;
    border-radius: 0.5rem;
    height: -moz-fit-content;
    height: fit-content;
  }
  .loginMainContainer--NTwAa .loginContainer--FsCPh {
    grid-column: 2 / 12;
    grid-row: 1;
    height: -moz-fit-content;
    height: fit-content;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/login/style.module.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sCAAA;EACA,4CAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AADF;AAVA;EAcI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AADJ;AAGI;EAAA;IACE,iBAAA;EAAJ;AACF;AArBA;EAuBM,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;AACN;AACM;EAAA;IACE,iBAAA;EAEN;AACF;AAhCA;EAiCQ,cAAA;AAER;AAnCA;EAsCM,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AAAN;AA9CA;EAiDQ,iBAAA;AAAR;AAEQ;EAAA;IACE,eAAA;EACR;AACF;AAtDA;EA0DM,uBAAA;EAAA,kBAAA;EACA,eAAA;AADN;AA1DA;EAgEI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;AAHJ;AAzEA;EA+EM,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAHN;AA/EA;EAuFQ,YAAA;EACA,WAAA;EACA,gBAAA;AALR;AApFA;EA8FM,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAPN;AA3FA;EAqGQ,cAAA;AAPR;AA9FA;EAyGQ,mBAAA;AARR;AAcA;EACE;IACE,sCAAA;IACA,4BAAA;IACA,eAAA;IACA,YAAA;EAZF;EAQA;IAOI,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,qBAAA;IACA,wBAAA;IAAA,mBAAA;EAZJ;EAAA;IAgBI,mBAAA;IACA,WAAA;IACA,wBAAA;IAAA,mBAAA;EAbJ;AACF","sourcesContent":["@import \"~@boclips-ui/styles/src/colors\";\n\n.loginMainContainer {\n  background-color: @blue-100;\n  display: grid;\n  height: 100vh;\n  min-height: 100%;\n  width: 100%;\n  gap: 1rem;\n  grid-template-columns: repeat(12, 1fr);\n  grid-template-rows: 1fr minmax(0, 950px) 1fr;\n  align-self: center;\n  justify-content: center;\n  color: @gray-900;\n\n  .hero {\n    position: relative;\n    grid-column: 2 / 8;\n    grid-row: 2;\n    align-self: center;\n\n    @media (max-height: 800px) {\n      align-self: start;\n    }\n    h1 {\n      position: relative;\n      z-index: 2;\n      font-size: 2.5rem;\n      margin-bottom: 4rem;\n\n      @media (max-width: 1147px) {\n        font-size: 1.6rem;\n      }\n\n      span {\n        color: @green;\n      }\n    }\n\n    .featureInfo {\n      position: relative;\n      z-index: 2;\n      display: flex;\n      flex-direction: row;\n      margin-bottom: 1rem;\n      max-width: 80%;\n      word-break: keep-all;\n      padding: 0.25rem 0;\n      border-radius: 0.25rem;\n\n      div {\n        font-size: 1.4rem;\n\n        @media (max-width: 1147px) {\n          font-size: 1rem;\n        }\n      }\n    }\n\n    .icon {\n      width: min-content;\n      margin-top: 2px;\n    }\n  }\n\n  .loginContainer {\n    grid-column: 8 / 12;\n    grid-row: 2;\n    background: @white;\n    border-radius: 0.5rem;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 3rem 4rem;\n    text-align: center;\n    position: relative;\n    height: fit-content;\n    align-self: center;\n\n    .loginIllustration {\n      width: 100%;\n      height: auto;\n      margin-top: 2rem;\n      max-width: 260px;\n    }\n\n    .logo {\n      img {\n        height: auto;\n        width: 100%;\n        max-width: 250px;\n      }\n    }\n\n    .actions {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start;\n      padding-top: 2rem;\n\n      .error {\n        color: @error;\n      }\n\n      > span {\n        margin-bottom: 1rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .loginMainContainer {\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto 1fr;\n    padding: 2rem 0;\n    height: 100%;\n\n    .hero {\n      position: relative;\n      grid-column: 2 / 12;\n      grid-row: 2;\n      padding: 1rem;\n      border-radius: 0.5rem;\n      height: fit-content;\n    }\n\n    .loginContainer {\n      grid-column: 2 / 12;\n      grid-row: 1;\n      height: fit-content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginMainContainer": `loginMainContainer--NTwAa`,
	"hero": `hero--vKRgs`,
	"featureInfo": `featureInfo--ulHeD`,
	"icon": `icon--BBi75`,
	"loginContainer": `loginContainer--FsCPh`,
	"loginIllustration": `loginIllustration--oKMGv`,
	"logo": `logo--OkmDN`,
	"actions": `actions--j9lGb`,
	"error": `error--pdMVs`
};
export default ___CSS_LOADER_EXPORT___;
